import { ObjectType, Property, Type } from '../types.js';
import { PropertyPath } from '../engine.js';
import { SchemaError } from '../errors/SchemaError.js';
import { ExternalFieldSchema } from '../DataSetService/yaml-models.js';
import { Schema } from '../schema.js';


export class PropertyPathParser {
  constructor(private schema: Schema) {

  }

  parsePropertyType(path: PropertyPath, type: ObjectType, external: ExternalFieldSchema): Type {
    const pathFragments = path.split('.');
    let currentType: Type = type;
    // let property: Property;
    let propertyType: string;

    pathFragments.forEach(fragment => {
      // Special case to handle options, products by id
      if (fragment === '_id') {
        propertyType = 'string';
        // property = new Property('_id', 'string');
      } else {
        if (currentType instanceof ObjectType) {
          const property = currentType.properties.find(prop => prop.name === fragment);
          if (property) {
            propertyType = property.type;
          } else {
            const externalProperty = currentType.externals.find(e => e.name === fragment);
            if (externalProperty) {
              propertyType = externalProperty.type;
            }
          }
        }
      }
      if (!propertyType) {
        throw SchemaError.invalidExternalPropertyPath(path, `"${type.name}" of "${external.name}" external field. Check "${fragment}" property`)
      }
      currentType = this.schema.getType(propertyType);
    });
    return currentType;
  }
}
